import React from 'react';
import {
  PinIcon,
  SearchIcon,
  RetailIcon,
  OfficeIcon,
  AgentFilledIcon,
} from '@domain-group/fe-co-icon';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import * as styles from './option.style';
import { Option } from '../types';

const FillAvatar = ({ avatar }: { avatar?: string }): JSX.Element => (
  <span css={styles.iconV5AvatarFill}>
    <Avatar
      shape="square"
      size="custom"
      colorScheme="light"
      imageUrl={avatar}
    />
  </span>
);

const AgencyLogo = ({
  avatar,
  backgroundColour,
}: {
  avatar: string;
  backgroundColour?: string;
}): JSX.Element => (
  <span css={styles.agencyLogoTile(backgroundColour)}>
    <img src={avatar} css={styles.agencyLogo} alt="" />
  </span>
);

export interface OptionIconProps {
  option: Option;
  useTypeaheadV5?: boolean;
}

const OptionIcon = ({
  option: { category, avatar, backgroundColour },
  useTypeaheadV5 = false,
}: OptionIconProps): JSX.Element | null => {
  if (!useTypeaheadV5) {
    switch (category) {
      case 'Suburb':
        return <PinIcon />;
      case 'Agent':
        return <Avatar size="small" colorScheme="light" imageUrl={avatar} />;
      case 'Agency':
        return <RetailIcon />;
      default:
        return null;
    }
  }

  switch (category) {
    case 'Suburb':
      return <SearchIcon css={styles.iconV5Location} />;
    case 'Agent':
      return avatar ? (
        <FillAvatar avatar={avatar} />
      ) : (
        <span css={styles.iconV5AgentFilledWrapper}>
          <AgentFilledIcon
            viewBox="0 0 18 20"
            css={styles.iconV5AgentFilledFill}
          />
        </span>
      );
    case 'Agency':
      return avatar ? (
        <AgencyLogo avatar={avatar} backgroundColour={backgroundColour} />
      ) : (
        <OfficeIcon />
      );
    default:
      return null;
  }
};

export default OptionIcon;
